import { GenericImageCard } from "./GenericImageCard";
export default GenericImageCard;
